import { useRef, useEffect } from "react";
import { Chart } from "chart.js/auto";
import { defaultColors } from "../../datas/colors";

export default function RadarChart() {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy(); // Destruir instância antiga ao recriar o gráfico
    }

    if (!chartRef.current) return; // Garante que o canvas já foi montado

    const ctx = chartRef.current.getContext("2d");
    chartInstance.current = new Chart(ctx, {
      type: "pie",
      data: {
        labels: [
          "Vargas",
          "República Velha",
          "Brasil Império",
          "Roma",
          "Guerras Mundiais",
          "Grécia",
          "Revolução Francesa",
          "Ditadura Militar",
          "Revolução Industrial",
        ],
        datasets: [
          {
            label: "Citações por Tema",
            data: [30, 2, 50, 31, 10, 8, 4, 30, 8],
            borderColor: "#3b82f6",
            backgroundColor: defaultColors,
            borderWidth: 0,
            pointRadius: 5,
            pointBackgroundColor: "#3b82f6",
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: "bottom",
          },
          tooltip: {
            enabled: true,
            backgroundColor: "#ffffff", // Fundo branco
            titleColor: "#333333", // Cor do título mais escura para melhor leitura
            titleFont: { weight: "bold", size: 14 }, // Fonte do título mais destacada
            bodyColor: "#444444", // Cor do corpo (habilidade + descrição)
            bodyFont: { size: 13 }, // Tamanho da fonte do corpo
            footerColor: "#1565C0", // Azul mais sofisticado para o footer
            footerFont: { weight: "bold", size: 12 }, // Fonte do footer destacada
            borderColor: "#DDDDDD", // Borda cinza clara
            borderWidth: 0,
            cornerRadius: 10, // Cantos mais arredondados
            padding: 12, // Mais espaço para melhor visualização
            displayColors: false,
            callbacks: {
              label: (context) => `${context.raw} citações`,
            },
          },
        },
        // scales: {
        //   r: {
        //     angleLines: {
        //       color: "#e5e7eb",
        //     },
        //     grid: {
        //       color: "#e5e7eb",
        //     },
        //     pointLabels: {
        //       font: {
        //         size: 14,
        //         weight: "bold",
        //       },
        //       color: "#374151",
        //     },
        //     ticks: {
        //       display: false,
        //       beginAtZero: false,
        //       font: {
        //         size: 12,
        //       },
        //       color: "#1f2937",
        //       stepSize: 5, // Ajustando o intervalo da escala
        //     },
        //   },
        // },
      },
    });

    return () => chartInstance.current.destroy(); // Limpar gráfico ao desmontar componente
  }, []);

  return (
    <div className="p-6 bg-white shadow-lg rounded-xl border border-gray-200">
      <h2 className="text-lg font-bold text-gray-900">
        Assuntos de História mais utilizados na prova do ENEM
      </h2>
      <p className="text-gray-500 text-sm">2009 - 2024</p>
      <div className="relative w-full h-72 mt-1">
        <canvas ref={chartRef}></canvas>
      </div>
    </div>
  );
}
